export { default as CreateInvestmentView } from './CreateInvestmentView';
